module.exports = __webpack_public_path__ + "img/bench_work.5a9b21f0.png";